<template>
  <div>
    <!-- Loading Timesheets -->
    <loadingCube v-if="!loaded" :loadingMessage="'TIMESHEETS'"></loadingCube>
    <!-- Submitting Timesheets -->
    <savingCube v-else-if="!loaded && submitting" :savingMessage="'SUBMITTING<br>TIMESHEETS'"></savingCube>
    <!-- Timesheet Entry -->
    <div v-else-if="loaded" id="submit_timesheets_new">
      <div class="overlay" v-if="saving_overlay">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-md-6 col-8 text-center inner">
            <loadingTemplate></loadingTemplate>
            <div class="d-block text-center inner-text">SAVING<br>TIMESHEETS</div>
            <div class="row">
              <div class="col-8 offset-2 mt-4">
                <div class="progress">
                  <div class="progress-bar" role="progressbar" :style="'width: ' + (save_for_later / timesheets.length * 100) + '%'" :aria-valuenow="save_for_later"
                       aria-valuemin="0" :aria-valuemax="timesheets.length"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlay" v-if="submitting_overlay">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-md-6 col-8 text-center inner">
            <loadingTemplate></loadingTemplate>
            <div class="d-block text-center inner-text">SUBMITTING<br>TIMESHEETS</div>
            <div class="row">
              <div class="col-8 offset-2 mt-4">
                <div class="progress">
                  <div class="progress-bar" role="progressbar" :style="'width: ' + (submit_auth_genius / timesheets.length * 100) + '%'" :aria-valuenow="submit_auth_genius"
                       aria-valuemin="0" :aria-valuemax="timesheets.length"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="[saving_overlay ? 'saving_class' : '', submitting_overlay ? 'saving_class' : '']">
        <!-- pay period and autosave explainer -->
        <div class="row mb-3">
          <div class="col-12">
            <h2 class="mb_1 bp_color">Timesheet submission for pay period beginning: {{ ts_submission_date | formatDate }}</h2>
            <!--            <h5 class="mb-0">This page performs an autosave every 5 minutes to ensure that you do not loose any work in progress.</h5>-->
            <!--            <p class="mb-0">Below is a list of all the locations which you have access to complete timesheets for.<br>-->
            <!--              Please fill in and submit your timesheet instructions for this pay period.</p>-->
          </div>
        </div>
        <!-- Location Accordion -->
        <div v-for="(o, j) in timesheets" class="order_timesheet" role="tablist" :key="j">
          <b-card no-body class="mb-3">
            <!-- Accordion -->
            <b-card-header header-tag="h3" role="tab" class="p-0">
              <b-button class="btn orcaBtn clearfix" block href="#" :class="check_all_submitted(o, j)" v-b-toggle="'accordion-' + j">
                <span class="float-left font-weight-bold text-left" style="font-size: 1rem; margin-top: 10px; margin-bottom: 10px; line-height: 1;">{{ o.order_location }}</span>
                <span class="icon chevron float-right" style="line-height: 16px; margin-top: 10px;"></span>
              </b-button>
            </b-card-header>
            <!-- Accordion content -> Submission Table -->
            <b-collapse :id="'accordion-' + j" accordion="my-accordion" role="tabpanel">
              <b-card-body :body-class="'p-0 timesheet_card_body'">
                <submit_table :key="j" :week="week" v-if="timesheets.length > 0" :order_index="j" :company_name="company_name"
                              :ts_records="o.records" :order_jobs="o.order_jobs" :totals="o.totals"
                              :submit_all_workers="submit_all_workers" :authorise_all_workers="authorise_all_workers"
                              :save_for_later="save_for_later" @change_save_for_later="change_save_for_later"
                              @increment_save_for_later="increment_save_for_later"
                              @increment_submission="increment_submission"
                              @trigger_reset="trigger_reset"
                              :trigger="o.trigger"
                              :submit_auth_genius="submit_auth_genius" @change_submit_auth_genius="change_submit_auth_genius"
                              :ms_opts_pre_add="ms_opts.pre_add" :ms_opts_post_add="ms_opts.post_add"
                              :ms_opts_pre_ded="ms_opts.pre_ded" :ms_opts_post_ded="ms_opts.post_ded"
                ></submit_table>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <!-- Select All worker buttons -->
        <div class="row mt-4" v-if="!submit_all_workers && !authorise_all_workers && !chk_all_submitted">
          <div class="col-lg-6 mt-2 mb-2">
            <strong>Please click on this button to select all workers on all sites ready for
              <span v-if="$store.state.auth.me.roles.includes('client_auth')">authorisation.</span>
              <span v-else-if="$store.state.auth.me.roles.includes('client_sub')">submission to <span v-if="crmType === 'payroll'">Genius</span><span v-else-if="crmType ===
                'recruitment'">V3</span>.</span></strong>
          </div>
          <div class="col-lg-6">
            <button v-if="$store.state.auth.me.roles.includes('client_sub') && !submit_all_workers" class="btn orcaBtn w-100 mb-4" @click.prevent="submit_all_workers_all_sites">
              Select All Workers ready for submission
            </button>
            <button v-if="$store.state.auth.me.roles.includes('client_auth') && !authorise_all_workers" class="btn orcaBtn w-100 mb-4"
                    @click.prevent="authorise_all_workers_all_sites">
              Select all Workers ready for authorisation
            </button>
          </div>
        </div>
        <!-- Certifying Text and checkbox -->
        <div class="row mb-3" v-if="!chk_all_submitted">
          <div class="col-12">
            <div style="text-align: left;">
              <p-check class="p-icon certify_check" style="vertical-align: top; font-size: 23px; margin-top: 5px;" v-model="agree_submit">
                <i slot="extra" class="icon fa fa-check"></i>
                <span id="certifyText">I certify that I am an authorised member of {{ company_name }} and that the above named persons have attended site and
                  should be paid for the total payments entered above.<br>
                  {{ company_name }} agrees to be bound by the Terms of Business of <span v-if="crmType === 'payroll'">Genius
              Money</span><span v-else-if="crmType === 'recruitment'">V3 Recruitment</span> as previously received and signed.<br>
                  Any retention payments indicated will be released to the sub-contractor upon instruction by {{ company_name }}.</span>
              </p-check>
            </div>
          </div>
        </div>
        <!-- Save for later and Submit buttons -->
        <div class="row mb-3" v-if="!chk_all_submitted">
          <div class="col-lg-6">
            <button v-if="!saving_auth_submit" :disabled="saving_for_later" class="btn orcaBtn grey_bg w-100 mb-2" @click.prevent="btn_for_later">
              <span v-if="saving_for_later" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving ...</span>
              <span v-else>Save to finish later</span>
            </button>
          </div>
          <div class="col-lg-6">
            <button v-if="!saving_for_later" :disabled="saving_auth_submit || !agree_submit" class="btn orcaBtn greenBtn w-100 mb-2" @click.prevent="btn_auth_genius">
              <span v-if="saving_auth_submit" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving & Submitting ...</span>
              <span v-else>Save & Submit for Auth/to <span v-if="crmType === 'payroll'">Genius</span><span v-else-if="crmType === 'recruitment'">V3</span></span>
            </button>
          </div>
        </div>
        <div class="row mb-3" v-if="chk_all_submitted">
          <div class="col-12">
            <p class="text-center font-weight-bold mb-0 mt-3" v-if="$store.state.auth.me.roles.includes('client_sub')">This pay period has now been submitted for invoicing and
              payroll.<br>You should shortly receive an email confirming the submission amounts.</p>
            <p class="text-center font-weight-bold mb-0 mt-3" v-if="$store.state.auth.me.roles.includes('client_auth')">This pay period has now been submitted for
              authorisation.</p>
          </div>
        </div>
        <!-- Preview table -->
        <div class="row preview_workers" v-if="checking">
          <div class="col-12" v-if="crmType === 'payroll' || (crmType === 'recruitment' && !$store.state.auth.me.recruitment)">
            <hr>
            <hr>
            <b-card header="Preview of worker payments" header-tag="h4" body-class="mb-3 p-3 record_card_body">
              <div class="row">
                <div class="col-12">
                  <h1 class="font-weight-bold bp_color mb-0">PREVIEW</h1>
                  <h5 class="font-weight-bold">The following is a preview per worker for all payments entered. <u>IT IS NOT AN INVOICE.</u></h5>
                  <p>Any workers highlighted in green have had their payments submitted for this pay period.</p>
                  <hr>
                </div>
                <div class="col-12">
                  <div class="table-responsive mb-3">
                    <table class="table table-striped table-sm" id="timesheet_submit_table">
                      <thead>
                      <tr>
                        <th scope="col" class="firstName">Name</th>
                        <th scope="col" class="preview_sites" :style="'z-index: ' + zindexcalc(j)" v-for="(o, j) in timesheets">
                          <div><span>{{ o.order_location }}</span></div>
                        </th>
                        <th scope="col" class="firstName">Pre Tax Addition</th>
                        <th scope="col" class="firstName">Post Tax Addition</th>
                        <th scope="col" class="firstName">Pre Tax Deduction</th>
                        <th scope="col" class="firstName">Post Tax Deduction</th>
                        <th scope="col" class="firstName">Total</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="w in preview_rows" :class="[w.genius_submitted ? 'submitted' : 'not']">
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.first_name }} {{ w.surname }}</div>
                          </div>
                        </td>
                        <td v-for="(o, j) in timesheets">
                          <div class="td_data_outer">
                            <div class="td_data">
                              {{ get_worker_site_total(w, o) }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_worker_pre_tax_addition(w) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_worker_post_tax_addition(w) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_worker_pre_tax_deduction(w) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_worker_post_tax_deduction(w) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">
                              {{ get_worker_invoice_total(w) | currency }}
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">Running Totals</div>
                          </div>
                        </td>
                        <td v-for="(o, j) in timesheets">
                          <div class="td_data_outer">
                            <div class="td_data">
                              {{ parseFloat(calc_total_site_totals(o)).toFixed(2) }}
                            </div>
                          </div>

                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_total_pre_tax_addition() | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_total_post_tax_addition() | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_total_pre_tax_deduction() | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_total_post_tax_deduction() | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_total_invoice_total() | currency }}</div>
                          </div>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import loadingTemplate from "components/layouts/loaders/cube_loading";
import savingCube from "loaders/record_saving";
import submit_table from "pages/clients/timesheets/submit_table";
import TimesheetDataTable from "pages/clients/timesheets/TimesheetDataTable";
import Vue from "vue";

export default {
  name: "selected_period_submit",
  props: ['ts_submission_date', 'company_name'],
  components: {TimesheetDataTable, submit_table, loadingCube, savingCube, loadingTemplate},
  data() {
    return {
      ms_opts: {
        pre_add: [],
        post_add: [],
        pre_ded: [],
        post_ded: []
      },

      trigger: false,
      checking: true,
      agree_submit: false,
      save_for_later: false,
      submit_auth_genius: false,
      saving_overlay: false,
      submitting_overlay: false,
      timesheets: [],
      loaded: false,
      submitting: false,
      show_pre_tax_add_desc: false,
      show_post_tax_add_desc: false,
      show_pre_tax_ded_desc: false,
      show_post_tax_ded_desc: false,
      saving_for_later: false,
      saving_auth_submit: false,
      submit_all_workers: false,
      authorise_all_workers: false,
      week: {},
      preview_rows: [],
    }
  },
  beforeMount() {
      //Removed due to bug with server responses and blank drop downs
    // axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_additions').then(res => this.ms_opts.pre_add = res.data);
    // axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_additions').then(res => this.ms_opts.post_add = res.data);
    // axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_deductions').then(res => this.ms_opts.pre_ded = res.data);
    // axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_deductions').then(res => this.ms_opts.post_ded = res.data);
    this.hardCodeTypes();
    this.get_info();
    // this.autosave(true);
  },
  computed: {
    chk_all_submitted() {
      let test = true;
      if (this.$store.state.auth.me.roles.includes('client_sub')) {
        Object.values(this.timesheets).forEach(o => {
          let c_submitted = Object.values(o.records).filter(a => a.check_submitted === true);
          if (Object.keys(c_submitted).length !== Object.keys(o.records).length) {
            test = false;
          }
          // return Object.keys(c_submitted).length !== Object.keys(o.records).length;
        })
      }
      else if (this.$store.state.auth.me.roles.includes('client_auth')) {
        Object.values(this.timesheets).forEach(o => {
          let authed = Object.values(o.records).filter(a => a.submit_for_auth === true);
          let auth_level = Object.values(o.records).filter(a => a.auth_level === o.order_jobs[0].auth_level);
          if ((Object.keys(authed).length !== Object.keys(o.records).length) || (Object.keys(auth_level).length !== Object.keys(o.records).length)) {
            test = false;
          }
          // return Object.keys(authed).length !== Object.keys(o.records).length;
        });
      }
      return test;
    }
  },
  methods: {
    hardCodeTypes(){
        this.ms_opts.pre_add = [
            {
                "id": 107,
                "crm_attribute_master_type_id": 29,
                "value": "Bonus"
            },
            {
                "id": 112,
                "crm_attribute_master_type_id": 29,
                "value": "Fee"
            },
            {
                "id": 162,
                "crm_attribute_master_type_id": 29,
                "value": "Fuel\/Mileage"
            },
            {
                "id": 111,
                "crm_attribute_master_type_id": 29,
                "value": "Loan"
            },
            {
                "id": 170,
                "crm_attribute_master_type_id": 29,
                "value": "Miscellaneous"
            },
            {
                "id": 108,
                "crm_attribute_master_type_id": 29,
                "value": "Overtime (Bonus)"
            },
            {
                "id": 110,
                "crm_attribute_master_type_id": 29,
                "value": "Price Work"
            }
        ];
        this.ms_opts.post_add = [
            {
                "id": 114,
                "crm_attribute_master_type_id": 30,
                "value": "Clothing"
            },
            {
                "id": 116,
                "crm_attribute_master_type_id": 30,
                "value": "Fuel \/ Mileage"
            },
            {
                "id": 171,
                "crm_attribute_master_type_id": 30,
                "value": "Miscellaneous"
            },
            {
                "id": 136,
                "crm_attribute_master_type_id": 30,
                "value": "Parking"
            },
            {
                "id": 157,
                "crm_attribute_master_type_id": 30,
                "value": "Subsistence"
            },
            {
                "id": 113,
                "crm_attribute_master_type_id": 30,
                "value": "Tools\/Materials"
            }
        ];
        this.ms_opts.pre_ded = [
            {
                "id": 119,
                "crm_attribute_master_type_id": 31,
                "value": "Loan"
            },
            {
                "id": 172,
                "crm_attribute_master_type_id": 31,
                "value": "Miscellaneous"
            },
            {
                "id": 118,
                "crm_attribute_master_type_id": 31,
                "value": "Over Payment"
            },
            {
                "id": 120,
                "crm_attribute_master_type_id": 31,
                "value": "Van Hire"
            }
        ];
        this.ms_opts.post_ded = [
            {
                "id": 123,
                "crm_attribute_master_type_id": 32,
                "value": "Clothing"
            },
            {
                "id": 128,
                "crm_attribute_master_type_id": 32,
                "value": "Fines"
            },
            {
                "id": 125,
                "crm_attribute_master_type_id": 32,
                "value": "Loan"
            },
            {
                "id": 173,
                "crm_attribute_master_type_id": 32,
                "value": "Miscellaneous"
            },
            {
                "id": 129,
                "crm_attribute_master_type_id": 32,
                "value": "Parking"
            },
            {
                "id": 122,
                "crm_attribute_master_type_id": 32,
                "value": "Tools\/Materials"
            },
            {
                "id": 121,
                "crm_attribute_master_type_id": 32,
                "value": "Training"
            },
            {
                "id": 124,
                "crm_attribute_master_type_id": 32,
                "value": "Van Hire"
            }
        ];
    },
    get_info() {
      // if (this.$store.state.auth.me.roles.includes('client_sub') || this.$store.state.auth.me.roles.includes('client_auth')) {
      // find assignments for order where contact is sub level and start/end date contains period submit date
      return axios.get(this.crmApiPath + 'timesheet_authorisation/orders/where/contact/' + this.$store.state.auth.me.contact_id, {
        params: {
          ts_submission_date: this.ts_submission_date,
          order_workers_by_direction: 'asc',
          order_workers_by: 'assignment.worker.person.surname',
          second_order_workers_by: 'assignment.worker.person.first_name',
        }
      }).then(orders_timesheet_auth => {
        // console.log(orders_timesheet_auth.data)
        // this.assigned_workers = orders_timesheet_auth.data;

        // Get the formatted week start day(date) for the client (i.e. what day the week starts)
        for (let j = 0; orders_timesheet_auth.data.length; j++) {
          if (orders_timesheet_auth.data[j].ts_records.length > 0) {
            for (let i = 0; i < orders_timesheet_auth.data[j].ts_records[0].timesheet_pay.length; i++) {
              this.week[i] = this.$moment.utc(orders_timesheet_auth.data[j].ts_records[0].timesheet_pay[i].pay_date).format('dddd DD/MM/YYYY')
            }
            break;
          }
        }

        new Promise(resolve => {

          for (let i = 0; i < orders_timesheet_auth.data.length; i++) {
            Vue.set(this.timesheets, i, {});
            Vue.set(this.timesheets[i], 'order_location', orders_timesheet_auth.data[i].location);
            Vue.set(this.timesheets[i], 'order_jobs', orders_timesheet_auth.data[i].order_jobs);
            Vue.set(this.timesheets[i], 'trigger', orders_timesheet_auth.data[i].trigger);
            Vue.set(this.timesheets[i], 'records', []);
            Vue.set(this.timesheets[i], 'totals', {});
            Vue.set(this.timesheets[i]['totals'], 'day_1_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'day_2_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'day_3_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'day_4_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'day_5_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'day_6_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'day_7_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'total_units', 0);
            Vue.set(this.timesheets[i]['totals'], 'total_b4_add_ded', 0);
            Vue.set(this.timesheets[i]['totals'], 'retention_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'pre_tax_add_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'post_tax_add_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'pre_tax_ded_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'post_tax_ded_total', 0);
            Vue.set(this.timesheets[i]['totals'], 'invoice_total', 0);

            // Auth levels for orders at locations
            let auth_levels = [];
            for (let a = 0; a < orders_timesheet_auth.data[i].order_jobs.length; a++) {
              auth_levels.push({
                'order_job_id': orders_timesheet_auth.data[i].order_jobs[a].id,
                'auth_level': orders_timesheet_auth.data[i].order_jobs[a].auth_level,
              })
            }
            // console.log(orders_timesheet_auth.data[i].ts_records.length)
            // console.log(orders_timesheet_auth.data[i].ts_records)
            for (let j = 0; j < orders_timesheet_auth.data[i].ts_records.length; j++) {
              let check_auth = orders_timesheet_auth.data[i].ts_records[j].auth_level === auth_levels.filter(al => al.order_job_id ===
                  orders_timesheet_auth.data[i].ts_records[j].order_job_id)[0].auth_level;

              Vue.set(this.timesheets[i]['records'], j, {});
              Vue.set(this.timesheets[i]['records'][j], 'ts_record', {});
//
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'id', orders_timesheet_auth.data[i].ts_records[j].id);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'worker_id', orders_timesheet_auth.data[i].ts_records[j].worker_id);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'assignment_id', orders_timesheet_auth.data[i].ts_records[j].assignment_id);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'order_job_id', orders_timesheet_auth.data[i].ts_records[j].order_job_id);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'company_id', orders_timesheet_auth.data[i].ts_records[j].company_id);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'pay_period_week', orders_timesheet_auth.data[i].ts_records[j].pay_period_week);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'pay_period_year', orders_timesheet_auth.data[i].ts_records[j].pay_period_year);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'for_work_end_week_date', orders_timesheet_auth.data[i].ts_records[j].for_work_end_week_date);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'total_hours', orders_timesheet_auth.data[i].ts_records[j].total_hours);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'total_price', orders_timesheet_auth.data[i].ts_records[j].total_price);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'total_pay_amount', orders_timesheet_auth.data[i].ts_records[j].total_pay_amount);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'retention_released', orders_timesheet_auth.data[i].ts_records[j].retention_released);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'retention_amount', orders_timesheet_auth.data[i].ts_records[j].retention_amount);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'pay_period_total', orders_timesheet_auth.data[i].ts_records[j].pay_period_total);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'margin_total', orders_timesheet_auth.data[i].ts_records[j].margin_total);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'back_next_week', orders_timesheet_auth.data[i].ts_records[j].back_next_week);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'auth_level', orders_timesheet_auth.data[i].ts_records[j].auth_level);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'worker_submitted', orders_timesheet_auth.data[i].ts_records[j].worker_submitted);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'company_submitted', orders_timesheet_auth.data[i].ts_records[j].company_submitted);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'check_submitted', orders_timesheet_auth.data[i].ts_records[j].check_submitted);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'consultant_approved', orders_timesheet_auth.data[i].ts_records[j].consultant_approved);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'finance_accounts_exported', orders_timesheet_auth.data[i].ts_records[j].finance_accounts_exported);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'finance_payroll_exported', orders_timesheet_auth.data[i].ts_records[j].finance_payroll_exported);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'finance_exported_date', orders_timesheet_auth.data[i].ts_records[j].finance_exported_date);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'inter_company_exported', orders_timesheet_auth.data[i].ts_records[j].inter_company_exported);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'deleted_at', orders_timesheet_auth.data[i].ts_records[j].deleted_at);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'created_at', orders_timesheet_auth.data[i].ts_records[j].created_at);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'updated_at', orders_timesheet_auth.data[i].ts_records[j].updated_at);
//
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'auth_with', orders_timesheet_auth.data[i].ts_records[j].auth_with);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'assignment', orders_timesheet_auth.data[i].ts_records[j].assignment);
//
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'timesheet_additions_deductions', orders_timesheet_auth.data[i].ts_records[j].timesheet_additions_deductions);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'timesheet_pay', orders_timesheet_auth.data[i].ts_records[j].timesheet_pay);
              Vue.set(this.timesheets[i]['records'][j]['ts_record'], 'timesheet_worker_invoice', orders_timesheet_auth.data[i].ts_records[j].timesheet_worker_invoice);
//
              Vue.set(this.timesheets[i]['records'][j], 'contact_job_auth_level', auth_levels.filter(al => al.order_job_id === orders_timesheet_auth.data[i].ts_records[j].order_job_id)[0].auth_level);
              Vue.set(this.timesheets[i]['records'][j], 'auth_level', orders_timesheet_auth.data[i].ts_records[j].auth_level);
              Vue.set(this.timesheets[i]['records'][j], 'auth_with', orders_timesheet_auth.data[i].ts_records[j].auth_with);
              Vue.set(this.timesheets[i]['records'][j], 'assignment_id', orders_timesheet_auth.data[i].ts_records[j].assignment_id);
              Vue.set(this.timesheets[i]['records'][j], 'worker_id', orders_timesheet_auth.data[i].ts_records[j].worker_id);
              Vue.set(this.timesheets[i]['records'][j], 'internal_finance_ref', orders_timesheet_auth.data[i].ts_records[j].assignment.worker.internal_finance_ref);
              Vue.set(this.timesheets[i]['records'][j], 'order_job_id', orders_timesheet_auth.data[i].ts_records[j].order_job_id);
              //
              Vue.set(this.timesheets[i]['records'][j], 'first_name', orders_timesheet_auth.data[i].ts_records[j].assignment.worker.person.first_name);
              Vue.set(this.timesheets[i]['records'][j], 'surname', orders_timesheet_auth.data[i].ts_records[j].assignment.worker.person.surname);
              Vue.set(this.timesheets[i]['records'][j], 'job_title', orders_timesheet_auth.data[i].ts_records[j].assignment.order_job.rel_order_position.job_title);
              Vue.set(this.timesheets[i]['records'][j], 'pay_type', orders_timesheet_auth.data[i].ts_records[j].assignment.position_rate.pay_type);
              Vue.set(this.timesheets[i]['records'][j], 'rate_type', orders_timesheet_auth.data[i].ts_records[j].assignment.position_rate.rate_type);
              if (this.crmType === 'recruitment' && this.$store.state.auth.me.recruitment) {
                Vue.set(this.timesheets[i]['records'][j], 'pay_rate', orders_timesheet_auth.data[i].ts_records[j].assignment.position_rate.admin_fee_amount);
              } else {
                Vue.set(this.timesheets[i]['records'][j], 'pay_rate', orders_timesheet_auth.data[i].ts_records[j].assignment.position_rate.pay_amount);
              }

              //
              Vue.set(this.timesheets[i]['records'][j], 'timesheet_pay', orders_timesheet_auth.data[i].ts_records[j].timesheet_pay);
              Vue.set(this.timesheets[i]['records'][j], 'timesheet_worker_invoice', orders_timesheet_auth.data[i].ts_records[j].timesheet_worker_invoice);
              //
              Vue.set(this.timesheets[i]['records'][j], 'total_units', orders_timesheet_auth.data[i].ts_records[j].total_hours);
              Vue.set(this.timesheets[i]['records'][j], 'total_before_additions_deductions', orders_timesheet_auth.data[i].ts_records[j].total_price);
              //
              Vue.set(this.timesheets[i]['records'][j], 'retention_percentage', orders_timesheet_auth.data[i].ts_records[j].assignment.position_rate.retention_percentage);
              Vue.set(this.timesheets[i]['records'][j], 'retention_amount', orders_timesheet_auth.data[i].ts_records[j].retention_amount);
              Vue.set(this.timesheets[i]['records'][j], 'retention_released', orders_timesheet_auth.data[i].ts_records[j].retention_released);
              //
              Vue.set(this.timesheets[i]['records'][j], 'addition_pre_tax', orders_timesheet_auth.data[i].ts_records[j].timesheet_additions_deductions.filter(tad =>
                  tad.add_ded_type_id === 29));
              Vue.set(this.timesheets[i]['records'][j], 'addition_post_tax', orders_timesheet_auth.data[i].ts_records[j].timesheet_additions_deductions.filter(tad =>
                  tad.add_ded_type_id === 30));
              Vue.set(this.timesheets[i]['records'][j], 'deduction_pre_tax', orders_timesheet_auth.data[i].ts_records[j].timesheet_additions_deductions.filter(tad =>
                  tad.add_ded_type_id === 31));
              Vue.set(this.timesheets[i]['records'][j], 'deduction_post_tax', orders_timesheet_auth.data[i].ts_records[j].timesheet_additions_deductions.filter(tad =>
                  tad.add_ded_type_id === 32));
              //
              Vue.set(this.timesheets[i]['records'][j], 'invoice_total', orders_timesheet_auth.data[i].ts_records[j].total_pay_amount);
              //
              Vue.set(this.timesheets[i]['records'][j], 'submit_for_auth', check_auth);
              Vue.set(this.timesheets[i]['records'][j], 'submit_to_genius', orders_timesheet_auth.data[i].ts_records[j].company_submitted);
              Vue.set(this.timesheets[i]['records'][j], 'check_submitted', orders_timesheet_auth.data[i].ts_records[j].check_submitted);
              Vue.set(this.timesheets[i]['records'][j], 'worker_submitted', orders_timesheet_auth.data[i].ts_records[j].worker_submitted);
            }

            if (i === orders_timesheet_auth.data.length - 1) {
              this.calc_preview_rows();
              resolve();
            }
          }

        }).then(() => {
          this.loaded = true;
          this.saving_for_later = false;
          this.saving_auth_submit = false;
        })
      })
    },

    calc_preview_rows() {
      return new Promise(resolve => {
        this.preview_rows = [];
        for (let i = 0; i < this.timesheets.length; i++) {
          for (let j = 0; j < Object.keys(this.timesheets[i].records).length; j++) {
            if (!this.preview_rows.some(e => e.worker_id === this.timesheets[i].records[j]['worker_id'])) {
              this.preview_rows.push({
                'worker_id': this.timesheets[i].records[j].worker_id,
                'first_name': this.timesheets[i].records[j].first_name,
                'surname': this.timesheets[i].records[j].surname,
                'genius_submitted': this.timesheets[i].records[j].submit_to_genius,
                'internal_finance_ref': this.timesheets[i].records[j].internal_finance_ref,
                [this.timesheets[i].records[j].order_job_id]: {
                  'auth_level': this.timesheets[i].records[j].auth_level,
                  'addition_pre_tax': this.timesheets[i].records[j].addition_pre_tax,
                  'addition_post_tax': this.timesheets[i].records[j].addition_post_tax,
                  'deduction_pre_tax': this.timesheets[i].records[j].deduction_pre_tax,
                  'deduction_post_tax': this.timesheets[i].records[j].deduction_post_tax,
                  'total_units': this.timesheets[i].records[j].total_units,
                  'total_before_additions_deductions': this.timesheets[i].records[j].total_before_additions_deductions,
                  'invoice_total': this.timesheets[i].records[j].invoice_total,
                  'job_title': this.timesheets[i].records[j].job_title,
                  'pay_rate': this.timesheets[i].records[j].pay_rate
                }
              })
            }
            else {
              let existing = this.preview_rows.find(r => r.worker_id === this.timesheets[i].records[j]['worker_id']);

              if (existing.worker_id === this.timesheets[i].records[j]['worker_id']) {
                if (!this.timesheets[i].records[j].submit_to_genius) {
                  existing.genius_submitted = this.timesheets[i].records[j].submit_to_genius;
                }
              }

              existing[this.timesheets[i].records[j].order_job_id] = {
                'auth_level': this.timesheets[i].records[j].auth_level,
                'addition_pre_tax': this.timesheets[i].records[j].addition_pre_tax,
                'addition_post_tax': this.timesheets[i].records[j].addition_post_tax,
                'deduction_pre_tax': this.timesheets[i].records[j].deduction_pre_tax,
                'deduction_post_tax': this.timesheets[i].records[j].deduction_post_tax,
                'total_units': this.timesheets[i].records[j].total_units,
                'total_before_additions_deductions': this.timesheets[i].records[j].total_before_additions_deductions,
                'invoice_total': this.timesheets[i].records[j].invoice_total,
                'job_title': this.timesheets[i].records[j].job_title,
                'pay_rate': this.timesheets[i].records[j].pay_rate
              }
            }
          }
          if (i === this.timesheets.length - 1) {
            this.preview_rows = this.preview_rows.sort((a, b) => (a.surname > b.surname ? 1 : -1))
            resolve()
          }
        }
      });
    },

    get_worker_site_total(worker, o) {
      let site_total = 0;
      for (let i = 0; i < o.order_jobs.length; i++) {
        if (worker.hasOwnProperty(o.order_jobs[i].id)) {
          site_total += worker[o.order_jobs[i].id].total_before_additions_deductions
        }
      }

      return site_total;
    },
    calc_worker_pre_tax_addition(worker) {
      let addition_pre_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
          for (let i = 0; i < worker[key].addition_pre_tax.length; i++) {
            addition_pre_tax += worker[key].addition_pre_tax[i].amount;
          }
        }
      }
      return addition_pre_tax;
    },
    calc_worker_post_tax_addition(worker) {
      let addition_post_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
          for (let i = 0; i < worker[key].addition_post_tax.length; i++) {
            addition_post_tax += worker[key].addition_post_tax[i].amount;
            // this.preview_post_tax_addition_total += worker[key].addition_post_tax[i].amount;
          }
        }
      }
      return addition_post_tax;
    },
    calc_worker_pre_tax_deduction(worker) {
      let deduction_pre_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
          for (let i = 0; i < worker[key].deduction_pre_tax.length; i++) {
            deduction_pre_tax += worker[key].deduction_pre_tax[i].amount;
            // this.preview_pre_tax_addition_total += worker[key].deduction_pre_tax[i].amount;
          }
        }
      }
      return deduction_pre_tax;
    },
    calc_worker_post_tax_deduction(worker) {
      let deduction_post_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
          for (let i = 0; i < worker[key].deduction_post_tax.length; i++) {
            deduction_post_tax += worker[key].deduction_post_tax[i].amount;
            // this.preview_post_tax_deduction_total += worker[key].deduction_post_tax[i].amount;
          }
        }
      }
      return deduction_post_tax;
    },
    get_worker_invoice_total(worker, o) {
      let invoice_total = 0;
      for (let b = 0; b < this.timesheets.length; b++) {
        for (let i = 0; i < this.timesheets[b].order_jobs.length; i++) {
          if (worker.hasOwnProperty(this.timesheets[b].order_jobs[i].id)) {
            invoice_total += worker[this.timesheets[b].order_jobs[i].id].invoice_total;
          }
        }
      }
      return invoice_total;
    },

    calc_total_site_totals(o) {
      let total = 0;
      for (let i = 0; i < Object.keys(o.records).length; i++) {
        total += o.records[i].total_before_additions_deductions;
      }
      return total;
    },
    calc_total_pre_tax_addition() {
      let total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
            if (this.preview_rows[i][key].hasOwnProperty('addition_pre_tax')) {
              for (let k = 0; k < this.preview_rows[i][key].addition_pre_tax.length; k++) {
                total += this.preview_rows[i][key].addition_pre_tax[k].amount;
              }
            }
          }
        }
      }
      return total;
    },
    calc_total_post_tax_addition() {
      let total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
            if (this.preview_rows[i][key].hasOwnProperty('addition_post_tax')) {
              for (let k = 0; k < this.preview_rows[i][key].addition_post_tax.length; k++) {
                total += this.preview_rows[i][key].addition_post_tax[k].amount;
              }
            }
          }
        }
      }
      return total;
    },
    calc_total_pre_tax_deduction() {
      let total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
            if (this.preview_rows[i][key].hasOwnProperty('deduction_pre_tax')) {
              for (let k = 0; k < this.preview_rows[i][key].deduction_pre_tax.length; k++) {
                total += this.preview_rows[i][key].deduction_pre_tax[k].amount;
              }
            }
          }
        }
      }
      return total;
    },
    calc_total_post_tax_deduction() {
      let total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
            if (this.preview_rows[i][key].hasOwnProperty('deduction_post_tax')) {
              for (let k = 0; k < this.preview_rows[i][key].deduction_post_tax.length; k++) {
                total += this.preview_rows[i][key].deduction_post_tax[k].amount;
              }
            }
          }
        }
      }
      return total;
    },
    calc_total_invoice_total() {
      let preview_invoice_total = 0;
      for (let i = 0; i < this.preview_rows.length; i++) {
        for (let key in this.preview_rows[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted') {
            preview_invoice_total += this.preview_rows[i][key].invoice_total;
          }
        }
      }
      return preview_invoice_total;
    },

    btn_for_later() {
      return new Promise(resolve => {
        //
        // this.checking redraws the preview section
        this.checking = false;
        this.calc_preview_rows().then(() => {
          // window.clearTimeout(this.auto_save_interval);
          // button display trigger
          this.saving_for_later = true;
          // trigger save for later on each location
          this.save_for_later = 0;

          this.saving_overlay = true;

          this.checking = true;

          resolve();
        });
      })
    },
    increment_save_for_later(number) {
      this.save_for_later = number;
    },
    change_save_for_later(order_index) {
      // console.log(this.timesheets[order_index])
      if (this.timesheets.length === order_index + 1) {
        this.get_info().then(() => {
          setTimeout(() => {
            for (let z = 0; z < this.timesheets.length; z++) {
              this.timesheets[z].trigger = true;
              // console.log(this.timesheets[z])
            }

            this.save_for_later = false;
            this.saving_for_later = false;

            this.saving_overlay = false;

            // restart autosave
            // this.autosave(true);
            // this.trigger = false;
          }, 750)
        });
      }
    },
    trigger_reset(order_index) {
      // console.log('here ' + order_index)
      this.timesheets[order_index].trigger = false;
    },
    btn_auth_genius() {
      if (this.$store.state.auth.me.roles.includes('client_sub')) {
        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Close Pay Period</div>' +
              '<div class="snotifyToast__body">' +
              'Do you wish to submit all timesheets and close this pay period to any further submissions? Have you also removed any workers not returing next week?' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
          buttons: [
            {
              text: 'Submit & Close Period', action: (toast) => {
                this.checking = false;
                this.calc_preview_rows().then(() => {
                  // window.clearTimeout(this.auto_save_interval);
                  this.submit_all_workers = true;
                  this.$nextTick(() => {
                    // btns display trigger
                    this.saving_auth_submit = true;
                    // trigger submit on each location
                    this.submit_auth_genius = 0;

                    this.submitting_overlay = true;

                    this.checking = true;
                    this.$snotify.remove(toast.id)
                  })
                });
              }
            },
            // {
            //   text: 'Submit only selected', action: (toast) => {
            //     this.checking = false;
            //     this.calc_preview_rows().then(() => {
            //       window.clearTimeout(this.auto_save_interval);
            //       this.$nextTick(() => {
            //         this.saving_auth_submit = true;
            //         this.submit_auth_genius = true;
            //         this.checking = true;
            //         this.$snotify.remove(toast.id)
            //       });
            //     });
            //   }
            // },
            {
              text: 'Cancel', action: (toast) => {
                this.$snotify.remove(toast.id)
              }
            }
          ]
        });
      }
      else {
        this.checking = false;
        this.saving_auth_submit = true;
        this.submit_auth_genius = true;
        this.checking = true;
      }
    },
    increment_submission(number) {
      this.submit_auth_genius = number;
    },

    submit_all_workers_all_sites() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Select all Workers on all Sites</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to select all workers on all sites ready for submission?' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.submit_all_workers = true;
              this.$snotify.remove(toast.id)
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },
    authorise_all_workers_all_sites() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Select all Workers on all Sites</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to select all all workers on all sites ready for authorisation?' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.authorise_all_workers = true;
              this.$snotify.remove(toast.id)
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },

    change_submit_auth_genius(order_index) {
      if (this.timesheets.length === order_index + 1) {

        this.submit_all().then(() => {
          this.loaded = false;
          this.get_info()
        });

        this.submit_auth_genius = false;
        this.saving_auth_submit = false;

        this.submitting_overlay = false;

        // restart autosave
        // this.autosave(true);
      }
    },
    submit_all() {
      return new Promise(resolve => {
        this.calc_preview_rows().then(() => {
          let contact_type = null;
          if (this.$store.state.auth.me.roles.includes('client_sub')) {
            contact_type = 'sub'
          }
          if (this.$store.state.auth.me.roles.includes('client_auth')) {
            contact_type = 'auth'
          }
          let order_job_auths = {};
          for (let i = 0; i < this.timesheets.length; i++) {
            for (let j = 0; j < this.timesheets[i].order_jobs.length; j++) {
              order_job_auths[this.timesheets[i].order_jobs[j].id] = this.timesheets[i].order_jobs[j].auth_level
            }
          }
          // console.log(order_job_auths);
          // if (this.$store.state.auth.me.roles.includes('client_sub')) {
          axios.post(this.crmApiPath + 'timesheet/submit_all_timesheets', {
                'timesheets': this.preview_rows,
                'company_name': this.company_name,
                'me': this.$store.state.auth.me,
                'contact_type': contact_type,
                'order_job_auths': order_job_auths,
                'ts_submission_date': this.$moment.utc(this.ts_submission_date).format('DD/MM/YYYY'),
              })
              .then(() => {resolve();});
          // }
          // else {
          //   resolve();
          // }
        });
      })
    },

    check_all_submitted(o, j) {
      if (this.$store.state.auth.me.roles.includes('client_sub')) {
        let submitted = Object.values(o.records).filter(a => a.submit_to_genius === true);
        let c_submitted = Object.values(o.records).filter(a => a.check_submitted === true);
        if (Object.keys(c_submitted).length === Object.keys(o.records).length) {
          return 'completed'
        }
      }
      else if (this.$store.state.auth.me.roles.includes('client_auth')) {
        let authed = Object.values(o.records).filter(a => a.submit_for_auth === true);
        if (Object.keys(authed).length === Object.keys(o.records).length) {
          return 'completed'
        }
      }
    },

    zindexcalc(index) {
      return 80 - index;
    },
  },
  beforeDestroy() {
    // window.clearTimeout(this.auto_save_interval);
  }
}
</script>

<style lang="scss">
.overlay {
  position:   absolute;
  background: rgba($bc_2, 0.5);
  top:        0;
  bottom:     0;
  left:       0;
  right:      0;
  z-index:    99;
  height:     100%;
  width:      100%;

  .inner {
    border-radius:    $border_radius;
    background-color: $bc_2;
    padding-top:      3rem;
    padding-bottom:   3rem;

    .inner-text {
      color:       white;
      font-size:   2rem;
      font-weight: bold;
      line-height: 1.2;
      margin-top:  40px;
    }

    .progress-bar {
      background-color: $bc_1;
    }
  }
}

.saving_class {
  height:   calc(100vh - 100px) !important;
  overflow: hidden;
}

#submit_timesheets_new {
  .timesheet_card_body {
    border:     1px solid $bc_4;
    margin-top: -6px;
  }

  #certifyText {
    font-size:    0.75em;
    line-height:  15px;
    display:      inline-block;
    //width:       calc(100% - 45px);
    width:        100%;
    padding-left: 40px;
    float:        right;
    white-space:  initial;
  }

  tfoot {
    position:   -webkit-sticky;
    position:   sticky;
    bottom:     0;
    left:       0;
    background: #666;
    z-index:    98;

    tr, td {
      position:   -webkit-sticky;
      position:   sticky;
      bottom:     0;
      left:       0;
      background: $white;
      z-index:    98;
    }

    td {
      padding: 0;
    }

    td > div {
      padding:       0 0.3rem;
      border-color:  #333333;
      border-width:  6px;
      border-style:  double;
      border-left:   none;
      border-right:  none;
      border-bottom: none;
      margin-bottom: 10px;
    }
  }

  .submitted {
    td {
      background: lighten($green, 40%);
    }
  }

  .preview_sites {
    height:         160px;
    white-space:    nowrap;
    vertical-align: inherit;
  }

  .preview_sites > div {
    transform: translate(5px, 50px) rotate(295deg);
    width:     55px;
  }

  .preview_sites > div > span {
    font-size:   0.75rem;
    padding:     0 5px;
    width:       165px;
    display:     block;
    white-space: normal;
    line-height: 12px;
  }

  .preview_workers {
    .card {
      .card-header {
        background-color: $card_header_background;
      }
    }
  }

  .card {
    .card-header {
      position:         relative;
      background-color: transparent;

      &:before, &:after {
        display: none;
      }

      .orcaBtn {
        background:                 #999999;
        border-bottom-left-radius:  0;
        border-bottom-right-radius: 0;
        line-height:                initial;

        &:hover, &:focus {
          background: darken(#333333, 5%);
        }

        &.not-collapsed {
          background: $bc_1;
        }

        .icon::before {
          display:                inline-block;
          font-style:             normal;
          font-variant:           normal;
          text-rendering:         auto;
          -webkit-font-smoothing: antialiased;
        }

        .chevron::before {
          font-family: "Font Awesome 5 Free";
          font-weight: 900;
          content:     "\f078";
          font-size:   1.25rem;
        }

        &.not-collapsed {
          .chevron::before {
            content: "\f077";
          }
        }

        &.completed {
          background: $green;
        }

        &.ready {
          background: $orange;
        }
      }
    }

    .card-body {
      float:   none;
      width:   100%;
      padding: 5px;
    }
  }

  .sm_btn {
    display:       inline-block;
    width:         auto;
    padding:       0 15px;
    line-height:   30px;
    font-size:     0.75rem;
    margin-top:    5px;
    margin-bottom: 5px;
  }
}
</style>
